import type { PageSectionEditorModel } from "@/lib/domain/site-content";
import { HeadingAlignmentField } from "./heading-alignment-field";
import { SectionRoleField } from "./section-role-field";
import styles from "./section-presentation-fields.module.css";

export function SectionPresentationFields({ sections, prefix, labels, onChange }: {
  sections: PageSectionEditorModel[];
  prefix: string;
  labels: Record<string, string>;
  onChange: (id: number, patch: Partial<PageSectionEditorModel>) => void;
}) {
  return <div className={styles.list}>
    {sections.filter(section => section.active && section.key !== "video").map(section => <div className={styles.row} key={section.id}>
      <strong>{labels[section.key] ?? section.title ?? section.key}</strong>
      <SectionRoleField label="Bölüm rolü" value={section.role} onChange={role => onChange(section.id, { role })}/>
      <HeadingAlignmentField name={`${prefix}-${section.id}-alignment`} value={section.textAlignment} onChange={textAlignment => onChange(section.id, { textAlignment })}/>
    </div>)}
  </div>;
}
